export class CreateFarmUseCase {
  constructor(repository){
    this.repository=repository
  }
  async execute(farm) {
    const resp= await this.repository.create(farm)

    return resp
  }
}
